import { DOCS_URL } from "../../../config/constants.js";
import TextCallout from "./TextCallout.svelte";

export default {
    component: TextCallout,
    name: "Text Callout",
    description: "Block of featured text",
    docsLink: `${DOCS_URL}/storybook/?path=/story/atoms-textcallout--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/text-recognition.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F8df02f58f05e441eb8f487e3df60ecd8",
    inputs: [
        {
            friendlyName: "Content",
            name: "title",
            type: "longText",
            required: true,
            helperText:
                "Supports markdown links: [link text](/url) and **bold text** for SEO. Line breaks are preserved.",
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "CTA Text 1",
            name: "linkText1",
            type: "string",
        },
        {
            friendlyName: "CTA Link 1",
            name: "link1",
            type: "string",
        },
        {
            friendlyName: "CTA Text 2",
            name: "linkText2",
            type: "string",
        },
        {
            friendlyName: "CTA Link 2",
            name: "link2",
            type: "string",
        },
    ],
};
